<template>
    <div class="sidebar-detail">
        <!-- :title="`${detailInfo.name || '----' } ${qrCode}`" -->
        <detail-header
            v-if="detailInfo"
            title="Pollen Processing 1"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        />

        <div v-if="detailInfo">
            <p class="detail-title">Details</p>
            <div>
                <table class="recording-detail-table">
                    <tr>
                        <td>Id</td>
                        <td>{{ detailInfo.id }}</td>
                    </tr>
                    <tr>
                        <td>Pollen QR Code</td>
                        <td>{{ qrCode }}</td>
                    </tr>
                    <tr>
                        <td>Pollen Palm</td>
                        <td>
                            <mpob-palm-format :cell="(detailInfo.pollen||{}).palm" /> 
                        </td>
                    </tr>
                    <tr>
                        <td>Fresh Weight (g)</td>
                        <td>{{ detailInfo.freshWeight || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Temperature (&#8451;)</td>
                        <td>{{ detailInfo.temperature || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Processed Date</td>
                        <td>{{ detailInfo.processedDate || "-" }}</td>
                    </tr>
                    <tr>
                        <td>To Be Discarded</td>
                        <td>{{ detailInfo.toBeDiscarded }}</td>
                    </tr>
                    <tr>
                        <td>Discard Reason</td>
                        <td>{{ detailInfo.discardReason || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Image</td>
                        <td>
                            <image-holder :images="detailInfo.recordingImages" />
                        </td>
                    </tr>
                    <tr>
                        <td>Remarks</td>
                        <td>{{ detailInfo.remarks || "-" }}</td>
                    </tr>
                </table>
            </div>

            <p class="detail-title detail-title-pd">Date Time</p>
            <div class="user-datetime-container">
                <table>
                    <tr>
                        <td>Modified</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Created</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from "./DetailHeader";
import { pollenProcessing1Get } from "@/api/pollen_processing_1";
import MPOBPalmFormat from "@/components/Progeny/MPOBPalmFormat";
import ImageHolder from "@/components/SidebarDetail/ImageHolder";

export default {
    components: {
        "detail-header": DetailHeader,
        "mpob-palm-format": MPOBPalmFormat,
        "image-holder": ImageHolder
    },
    props: {
        infoSidebarId: {
            type: Number | String
        }
    },
    data() {
        return {
            detailInfo: null
        };
    },
    computed: {
        qrCode() {
            return this.detailInfo?.pollen?.qrCode?.code || "-";
        } 
    },
    watch: {
        infoSidebarId: {
            immediate: true,
            handler() {
                this.getDetails();
            },
        }
    },
    methods: {
        async getDetails() {
            if (this.infoSidebarId) {
                var res = await pollenProcessing1Get({ Id: this.infoSidebarId });
                if (res) {
                    this.detailInfo = res;
                }
            }
        },
        refreshDetailPage() {
            this.getDetails();
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        }
    },
};
</script>

<style scoped>
.stepper-container {
    padding: var(--space-16) 0;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/PollenProcessing1Sidebar.vue